import React from 'react'
import BuyGood from "../assets/buygoods_black.png"

const Footer = () => {
    return (
        <div className='w-full bg-black  '>
            <div className='flex flex-col gap-5  p-6 pb-0'>
                <div className='flex sm:flex-row flex-col  items-start gap-5'>
                    <img src={BuyGood} />
                    <p className='text-white text-xs'>
                        BuyGoods is the retailer of this product. BuyGoods is a registered trademark of BuyGoods, a Delaware corporation located at 1201 N Orange Street Suite #7223, Wilmington, DE, 19801, USA and used by permission. BuyGoods role as retailer does not constitute an endorsement, approval or review of this product or any claim, statement or opinion used in promotion of this product. Statements on this website have not been evaluated by the Food and Drug Administration. Products are not intended to diagnose, treat, cure or prevent any disease.                    </p>
                </div>



            </div>

        </div>
    )
}

export default Footer
